import {useState, useEffect} from 'react';
import styled from '@emotion/styled';

import { ActionButton } from '../../../utils/Common';

import { Tooltip, Popover, IconButton, Button } from '@mui/material';

import useServiceDashboardStore from '../../../store/service_dashboard';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import useSnackbarStore from '../../../store/snackbar';

import DragIndicatorRoundedIcon from '@mui/icons-material/DragIndicatorRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';
import PreviewRoundedIcon from '@mui/icons-material/PreviewRounded';
import CollectionsBookmarkRoundedIcon from '@mui/icons-material/CollectionsBookmarkRounded';

import { saveStationView } from '../apiService';

const Draggable = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.border};
  min-width: 18rem;
`;

const DragContent = styled.div`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  align-items: center;
  gap: 1.5rem;
  padding: .6rem 1rem;
`;

const DragHandle = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  /* padding: 1rem .3rem; */
  align-self: stretch;
  background-color: ${props => props.theme.colors.darkBg};
  border-right: 1px solid ${props => props.theme.colors.border};
`;


const StationsComponent = () => {
  const sortedStations = useServiceDashboardStore(state => state.sortedStations)
  const setSortedStations = useServiceDashboardStore(state => state.setSortedStations);

  const [draggedIndex, setDraggedIndex] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const showSnackbar = useSnackbarStore((state) => state.showSnackbar);

  // useEffect(() => {
  //   setSortedStations(defaultStations);
  // }, [])

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null);
  }

  /* Draggable functions */
  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDragOver = (index) => {
    if (draggedIndex === index) return;
    const reorderedStations = [...sortedStations];
    const [removed] = reorderedStations.splice(draggedIndex, 1);
    reorderedStations.splice(index, 0, removed);
    setDraggedIndex(index);
    setSortedStations(reorderedStations);
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
  };

  /* End Draggable Functions */

  const toggleStation = (index) => {
    let newStations = sortedStations.map((station, i) => {
      if (i === index) {
        // Create a new object with the updated active property
        return { ...station, active: !station.active };
      }
      return station;
    });
    setSortedStations(newStations);
  }

  const queryClient = useQueryClient();

  const updateMutation = useMutation({
    mutationFn: () => saveStationView(sortedStations),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["settings", "stations", "station_view"] });
      showSnackbar('Updated successfully!', 'success');
      handleClose();
    },
    onError: () => {
      showSnackbar('Failed to update!', 'error');
    }
  })

  return (
    <>
    <Tooltip title="Sort Stations">
      <Button color="icon" variant="outlined" size="large" onClick={handleClick} sx={{minWidth: "unset", px: 1}}><PreviewRoundedIcon /></Button>
    </Tooltip>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div>
          {sortedStations.map(({name, active}, index) => (
            <Draggable 
              key={name} 
              draggable="true"
              onDragStart={() => handleDragStart(index)}
              onDragOver={(e) => {
                e.preventDefault();
                handleDragOver(index)
              }}
              onDragEnd={handleDragEnd}
              >
              <DragHandle><DragIndicatorRoundedIcon color="basic" /></DragHandle>
              <DragContent>{name}
                <IconButton size="small" onClick={() => toggleStation(index)}>
                  {active ? <VisibilityRoundedIcon color="primary" /> : <VisibilityOffRoundedIcon />}
                </IconButton>
                </DragContent> 
            </Draggable>
          ))}
        </div>
        <div style={{padding: ".3rem"}}>
          <Button color="secondary" startIcon={<CollectionsBookmarkRoundedIcon />} onClick={updateMutation.mutate} variant="contained" fullWidth>Save Station View</Button>
        </div>
      </Popover>
    </>
  )
};

export default StationsComponent;